<template>
  <v-card
    :class="$vuetify.breakpoint.mdAndUp ? 'pa-5' : 'pa-0'"
    style="max-width: 600px;margin-left: auto;margin-right:auto;"
    class="elevation-0"
  >
    <v-card-text>
      <div class="py-3">
        <h1 class="text-h5">
          Sähköinen ostotoimeksianto
        </h1>
        <p>Syötä pääsykoodi kirjautuaksesi sisään.</p>
      </div>
      <v-form
        @submit.prevent="submitCode()"
      >
        <v-text-field
          v-model="passCode"
          class="mt-3 mb-1"
          type="password"
          outlined
          hide-details
          append-icon="lock"
          label="Pääsykoodi"
        />
        <v-alert
          v-if="fail"
          type="warning"
          class="mt-2"
        >
          Virheellinen pääsykoodi. Yritä uudelleen
        </v-alert>
        <v-checkbox
          v-model="acceptGdpr"
          hide-details
          class="mt-3"
          label="Hyväksyn henkilötietojeni sähköisen käsittelyn"
        />
        <p class="text-caption mt-2">
          Sähköinen ostotoimeksianto edellyttää henkilötietojen automaattista käsittelyä ja tietojen
          tallennusta asiakasrekisteriimme.
          <a @click="showGdpr = true">
            EU:n tietosuoja-asetuksen (GDPR) mukainen tietosuojaseloste.
          </a>
        </p>
        <v-dialog v-model="showGdpr" max-width="600">
          <gdpr/>
        </v-dialog>
        <div class="grid grid-actions">
          <v-btn
            :disabled="!codeValid || !acceptGdpr"
            :loading="loading"
            color="primary"
            type="submit"
          >
            Ok
          </v-btn>
        </div>
      </v-form>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  name: 'BuyOrderPassCode',
  components: {
    gdpr: () => import('@/components/Gdpr'),
  },
  data: () => ({
    loading: false,
    passCode: '',
    acceptGdpr: false,
    fail: false,
    showGdpr: false,
  }),
  computed: {
    codeValid() {
      return this.passCode.length > 0;
    },
    id() {
      return this.$route.params.id;
    },
  },
  methods: {
    ...mapActions({
      submitPass: 'buyOrderPass/create',
      // getAgreement: 'commissionAgreement/getOne',
    }),
    async submitCode() {
      this.loading = true;
      try {
        await this.submitPass({
          data: {
            buyOrderId: this.id,
            passCode: this.passCode,
          },
        });
        this.$bus.$emit('RELOAD_BUY_ORDER');
        // await this.getAgreement({ id: this.id });
        this.fail = false;
      } catch (e) {
        console.warn(e);
        this.fail = true;
      }
      this.loading = false;
    },
  },
};
</script>
